import styled from '@emotion/styled';
import { DropdownButton } from 'react-bootstrap';

export const StyledDropdownButton = styled(DropdownButton)`
	button {
		background: transparent !important;
		border: none !important;
		&.btn-outline-primary.dropdown-toggle {
			background-color: #fff !important;
			box-shadow: none !important;
			border-color: #ced4da !important;
		}
		&.btn-primary:focus,
		&.btn-primary.focus {
			box-shadow: none !important;
		}
	}

	.dropdown-menu {
		min-width: auto !important;
	}
`;
